<template>
  <ChecklistModal
    :title="$tc('unitCatalog', 1)"
    :value="internalValue"
    @input="updateFilter"
    :items="fetch"
    :transform="item => ({ value: item.id, label: item.internalName })"
  >
    <template #input="{ items }">
      <div class="elder-input">
        <label class="elder-input__label">{{ $tc('unitCatalog', 1) }}</label>
        <ButtonComponent class="elder-input__wrapper" :icon="['fal', 'puzzle-piece']" icon-placement="left">
          <template #label>
            <span v-html="getLabel(items)"></span>
            <Badge class="ml-1" v-if="internalValue.length > limit" :value="`+ ${internalValue.length - limit}`" />
            <FontAwesomeIcon class="ml-1" :icon="['fal', 'angle-down']" size="sm" />
          </template>
        </ButtonComponent>
      </div>
    </template>
  </ChecklistModal>
</template>

<script>
import { mapActions } from 'vuex'
import fetch from '@/fetch'

import { ButtonComponent } from 'vue-elder-button'
import ChecklistModal from '@/components/Select/ChecklistModal'
import Badge from '@/components/Badge'

export default {
  props: ['value', 'options'],
  watch: {
    valueComp() {
      if (this.valueComp.length && !this.internalValue.length) return this.fetchInitial()
      this.internalValue = this.internalValue.filter(i => this.valueComp.includes(i.id))
    },
  },
  data() {
    return {
      internalValue: [],
      limit: 1,
    }
  },
  computed: {
    valueComp() {
      return this.value instanceof Array ? this.value : [this.value].filter(Boolean)
    },
  },
  methods: {
    ...mapActions('ResidentialTemplate', ['fetch']),
    getLabel(items) {
      return items.length
        ? `${items
            .slice(0, this.limit)
            .map(({ internalName }) => internalName)
            .join(', ')}`
        : this.$t('select')
    },
    updateFilter(value) {
      this.internalValue = value
      this.$emit(
        'input',
        value.map(i => i.id),
      )
    },
    fetchInitial() {
      let params = new URLSearchParams()
      params.append('field.id', 'id')
      params.append('field.internalName', 'internalName|name')
      this.valueComp.forEach(v => params.append('ids', v))

      fetch(`/api/resource/residentialTemplate?${params.toString()}`)
        .then(res => res.json())
        .then(data => (this.internalValue = data))
    },
  },
  components: {
    ChecklistModal,
    ButtonComponent,
    Badge,
  },
}
</script>
